module.exports = __webpack_public_path__ + "img/es-pc-step-3.028ca5cb.png";